<div class="actions" #modalElement>
	<div [class]="'actions-wrapper ' + wrapperClass">
		<ng-content></ng-content>
	</div>
    @if (showBackdrop) {
        <div class="actions-backdrop"></div>
    }
</div>
